// RingGauge.jsx
import React from "react";
import { clamp } from "../utils/math";

export default function RingGauge({
  value01 = 0,
  label,
  helper, // ✅ new: nicer secondary line (optional)
  centerTop,
  centerBottom,
  warnAt = 0.8,
  critAt = 0.95,
  size = 138,
}) {
  const v = clamp(value01, 0, 1);
  const stroke = 10;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  const dash = c * v;
  const gap = c - dash;

  const zoneColor = v >= critAt ? "#dc2626" : v >= warnAt ? "#b45309" : "#16a34a";

  const tick = (at) => {
    const angle = (at * 270 - 135) * (Math.PI / 180);
    const x = size / 2 + Math.cos(angle) * r;
    const y = size / 2 + Math.sin(angle) * r;
    return { x, y };
  };

  const warnTick = tick(warnAt);
  const critTick = tick(critAt);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: 14, alignItems: "center" }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: "block" }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(15,23,42,0.088)"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${c * 0.75} ${c}`}
          transform={`rotate(135 ${size / 2} ${size / 2})`}
        />

        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={zoneColor}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${gap}`}
          transform={`rotate(135 ${size / 2} ${size / 2})`}
          style={{ filter: "drop-shadow(0 1px 2px rgba(16,24,40,0.06))" }}
        />

        <circle cx={warnTick.x} cy={warnTick.y} r="2.6" fill="#b45309" opacity="0.9" />
        <circle cx={critTick.x} cy={critTick.y} r="2.6" fill="#dc2626" opacity="0.9" />

        <text x="50%" y="48%" textAnchor="middle" fontSize="18" fontWeight="800" fill="#15171c">
          {centerTop}
        </text>
        <text x="50%" y="62%" textAnchor="middle" fontSize="10" fill="#4b5563">
          {centerBottom}
        </text>
      </svg>

      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 12, fontWeight: 800, opacity: 0.9 }}>
          {label}
        </div>

        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.72 }}>
          {helper || `Thresholds: warn ${Math.round(warnAt * 100)}% · critical ${Math.round(critAt * 100)}%`}
        </div>
      </div>
    </div>
  );
}
